export const TreeUtil = {
	/**
	 * @param {Array} data - 원본 데이터 배열
	 * @param {String} sortField - 정렬 기준 필드명
	 * @param {String} idField - 고유 ID 필드명 (기본: 'id')
	 * @param {String} parentIdField - 부모 ID 필드명 (기본: 'parentId')
	 */
	sort: (data, idField = 'id', parentIdField = 'parentId', sortField = 'sortOrder', level = 'level') => {
		if (!data || data.length === 0) return [];

		// 1. ID 기준으로 데이터를 맵핑 (검색 속도 최적화)
		const map = {};
		data.forEach(item => {
			map[item[idField]] = { ...item, children: [] };
		});

		// 2. 부모-자식 관계 트리 구성
		const roots = [];
		data.forEach(item => {
			const node = map[item[idField]];
			const parentId = item[parentIdField];

			// 부모가 존재하고 맵에 있다면 자식으로 추가, 아니면 루트로 간주
			if (parentId && map[parentId]) {
				map[parentId].children.push(node);
			} else {
				roots.push(node);
			}
		});

		// 3. 재귀적으로 정렬하는 함수
		const sortNodes = (nodes) => {
			nodes.sort((a, b) => {
				const valA = a[sortField];
				const valB = b[sortField];

				// 숫자/문자열 자동 판별 정렬
				if (typeof valA === 'number' && typeof valB === 'number') {
					return valA - valB;
				}
				return String(valA || '').localeCompare(String(valB || ''));
			});
			// 자식 노드들도 재귀적으로 정렬
			nodes.forEach(node => {
				if (node.children.length > 0) sortNodes(node.children);
			});
		};

		sortNodes(roots);

		// 4. 다시 평탄화 (Flat Array) 하며 level 주입
		const result = [];
		const flatten = (nodes, currentLevel = 1) => { // currentLevel 파라미터 추가
			nodes.forEach(node => {
				// level 컬럼에 현재 깊이값 할당
				node[level] = currentLevel;

				const { children, ...item } = node;
				result.push(item);

				// 자식 노드는 level을 1 증가시켜 재귀 호출
				if (children.length > 0) flatten(children, currentLevel + 1);
			});
		};

		flatten(roots);

		return result;
	}
};